import axios from "../axios";

export const fetchBeneficiariesStarted = () => {
  return {
    type: "GET_BENEFICIARIES_STARTED",
  };
};

export const fetchBeneficiariesSuccess = (post) => {
  return {
    type: "GET_BENEFICIARIES_SUCCESS",
    data: post,
  };
};

export const fetchBeneficiariesFailure = (error) => {
  console.error("Unable to get beneficiaries data");
  return {
    type: "GET_BENEFICIARIES_FAILURE",
    data: error,
  };
};

export const fetchBeneficiaries = () => {
  return (dispatch) => {
    dispatch(fetchBeneficiariesStarted());
    return axios
      .get("/beneficiaries")
      .then((response) => {
        dispatch(fetchBeneficiariesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchBeneficiariesFailure(error));
      });
  };
};

export const addBeneficiariesStarted = (data) => {
  return {
    type: "ADD_BENEFICIARIES_STARTED",
    data: data,
  };
};

export const addBeneficiariesSuccess = (data) => {
  return {
    type: "ADD_BENEFICIARIES_SUCCESS",
    data: data,
  };
};

export const addBeneficiariesFailure = (error) => {
  console.log("Unable to add beneficiaries data");
  return {
    type: "ADD_BENEFICIARIES_FAILURE",
    data: error,
  };
};

export const addBeneficiaries = (data) => {
  return (dispatch) => {
    dispatch(addBeneficiariesStarted(data));
    return axios
      .post("/beneficiaries", data)
      .then((response) => {
        dispatch(addBeneficiariesSuccess(response));
        dispatch(fetchBeneficiaries());
      })
      .catch((error) => {
        dispatch(addBeneficiariesFailure(error));
      });
  };
};

export const deleteBeneficiariesStarted = (data) => {
  return {
    type: "DELETE_BENEFICIARIES_STARTED",
    data: data,
  };
};

export const deleteBeneficiariesSuccess = (data) => {
  return {
    type: "DELETE_BENEFICIAIRES_SUCCESS",
    data: data,
  };
};

export const deleteBeneficiariesFailure = (error) => {
  console.log("Unable to delete beneficiaries data");
  return {
    type: "DELETE_BENEFICIARIES_FAILURE",
    data: error,
  };
};

export const deleteBeneficiaries = (data) => {
  return (dispatch) => {
    dispatch(deleteBeneficiariesStarted(data));
    return axios
      .delete("/beneficiaries/" + data.id)
      .then((response) => {
        dispatch(deleteBeneficiariesSuccess(response));
        dispatch(fetchBeneficiaries());
      })
      .catch((error) => {
        dispatch(deleteBeneficiariesFailure(error));
      });
  };
};

export const updateBeneficiariesStarted = (data) => {
  return {
    type: "UPDATE_BENEFICIARIES_STARTED",
    data: data,
  };
};

export const updateBeneficiariesSuccess = (data) => {
  return {
    type: "UPDATE_BENEFICIARIES_SUCCESS",
    data: data,
  };
};

export const updateBeneficiariesFailure = (error) => {
  console.log("Unable to update beneficiaries data");
  return {
    type: "UPDATE_BENEFICIARIES_FAILURE",
    data: error,
  };
};

export const updateBeneficiaries = (data) => {
  return (dispatch) => {
    dispatch(updateBeneficiariesStarted(data));
    return axios
      .put("/beneficiaries/" + data.id, {
        beneficiary_name: data.beneficiary_name,
      })
      .then((response) => {
        dispatch(updateBeneficiariesSuccess(response));
        dispatch(fetchBeneficiaries());
      })
      .catch((error) => {
        dispatch(updateBeneficiariesFailure(error));
      });
  };
};
